

/**
 * @fileOverview ImageGalleryView View Module File
 *
 * The ImageGalleryView handles the layout and swipe + next / previous interaction for a variety of carousel types.  It calculates
 * the the inline styles needed for the carousels to be responsive, and also handles subscribing to global events and recalculates
 * the needed styles on context change and window resize events.  In addition, it provides an interface for one or more
 * external controllers allowing them to move to a slide location by providing a target div ID.  It can also publish an
 * event that allows one or more controllers to run a custom callback even if the controller was not what updated the
 * carousel.
 *
 * @author jmaki
 * @contributor aranfelt
 * @version 1.0
 */

(function (context) {
    'use strict';

    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('kungfu/MediaGrid/ImageGalleryView',['require','jquery','models/Features','GlobalEventDispatcher','GlobalResizeListener','kungfu/MediaGrid/ImageGalleryController'],function (require) {

        var $ = require('jquery');
        var features = require('models/Features');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        var GlobalResizeListener = require('GlobalResizeListener');
        var CarouselController = require('kungfu/MediaGrid/ImageGalleryController');

        /**
         * Scrolling X Threshold before the carousel registers something as a 'scroll'
         *
         * @property SCROLL_X_THRESHOLD
         * @static
         * @final
         * @type {number}
         */

        /**
         * Description
         *
         * @name ImageGalleryView
         * @class ImageGalleryView handles the layout of the carousels
         * @constructor
         *
         * @since 1.0
         */
        var ImageGalleryView = function (carouselId, mediagallery, imgId) {
            this.$carousel = $(carouselId);                 // A block level element that wraps around the list of slides, the 'base' pf the module
            this.mediagallery = mediagallery;
            this.imgId = '#' + imgId;
            //this.gallerycontainer = imgContainer;
            this.$carouselList = undefined;                 // reference to the carousel list, the thing that animates
            this.$slides = undefined;                       // collection of slide elements
            this.firstSlideId =undefined;
            this.slideCount = undefined;                    // slideCount
            this.transitionSpeed = undefined;               // transition speed
            this.currentSlide = 0;                          // the current slide index
            this.isAnimating = false;                       // a boolean that is set to true for the duration of a transition
            this.isLooping = false;                         // a boolean that indicates if the ImageGalleryView is of the looping variety
            this.isFlexible = true;                        // a boolean that indicates if the ImageGalleryView is of the flexible type
            this.isEnabled = undefined;                     // a boolean that indicates if the ImageGalleryView is currently enabled
            this.thumbnailControllerContainerId = undefined;
            this.mobileThumbnailContollerContainerId = undefined;
            this.heroCarouselAltController = undefined;
            this.heroCarouselAltControllerMobile = undefined;
            /**
             * This method gets an EventDispatcher object from the application that can be used to subscribe to events of interest
             * or publish event notifications to the rest of the application.
             *
             * @type {EventDispatcher}
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application

            /**
             *
             * @type {ResizeListener}
             */
            this.resizeListener = GlobalResizeListener.getResizeListener();
            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         *
         * @returns {ImageGalleryView}
         * @since 1.0
         */
        ImageGalleryView.prototype.init = function () {
            // disable the view interactions until the initialization is completed
            this.isEnabled = false;

            this.transitionSpeed = 500;

            // escape early if no carousel is defined
            if (this.$carousel.length < 1) {
                return this;
            }
            /**
             * set up the handlers, create child elements, layout the elements, enable the view, and go to the first slide
             */
            return this.setupHandlers()
                .createChildren()
                .goToSlide(this.imgId);

        };

        /**
         * Binds the scope of any handler functions, binds functions to  events via the event dispatcher
         *
         * @returns {ImageGalleryView}
         * @since 1.0
         */
        ImageGalleryView.prototype.setupHandlers = function () {
            // subscribe to relevant events, causing a layout when they occur
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.layout.bind(this));
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE, this.layout.bind(this));
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.MODAL_OPEN, this.layout.bind(this));

            return this;
        };

        /**
         * Create any child objects or references to DOM elements, also
         * Should only be run on initialization of the view
         *
         * @returns {ImageGalleryView}
         * @since 1.0
         */
        ImageGalleryView.prototype.createChildren = function () {
            if (this.$carousel.data('isLooping') === true) {
                this.isLooping = true;
            }
            $msg('in ImageGalleryView this.$carousel '+ this.$carousel.attr('class'));
            this.$carouselList = this.$carousel.find('.js-galleryList'); // this selector will be scoped to within the parent dom element
            this.$slides = this.$carouselList.children();                 //the listItems will be the children
            //testing
            $msg('slides length '+this.$slides.length);
            this.$slides.each(function(e) {
                $msg('checking each slide id '+$(this).attr('id'));
            });
            // records the first and last slide ID's
            this.firstSlideId = '#' + this.$slides.first().attr('id').toString();

            this.slideCount = this.$slides.length;   // the total number of slides, before appending or pre-pending slides used in looping

            // sets a flag to determine in which direction the slides should animate
            this.shouldUseRTL = $('body').hasClass('rtl');

            // determines if this is a hero slide
            if (this.$carousel.data('isFlexible') === true) {
                this.isFlexible = true;
            }
            return this;
        };

        /**
         * Performs measurements and applies any positioning style logic
         * Should be run anytime the parent layout changes
         *
         * @returns {ImageGalleryView}
         * @since 1.0
         */
        ImageGalleryView.prototype.layout = function () {

            this.enable();

            return this;
        };

        ImageGalleryView.prototype.updateContent = function () {
            this.imgContainer.html(this.imgContent);

            return this;
        };

//    ImageGalleryView.prototype.onLayout = function() {
//       throw new Error('onLayout not implemented!');
//    };

        /**
         * Sets the slide width to the proper %s
         * @return {*}
         */

        /**
         * Used to go to the first slide, checks to see if the ImageGalleryView is Looping and then goes to the true first slide
         * cache the transition speed, then set it to zero and jump to the target frame, and set the transition back to
         * whatever it was when the method was called
         *
         * @return {ImageGalleryView}
         */
        ImageGalleryView.prototype.goToFirstSlide = function () {
            var self = this;

            var indexOfSlide = this.$slides.index($(this.firstSlideId)) ;
            //this.setCurrentSlide(indexOfSlide);
            this.$slides.each(function (i, e) {
                //$msg(' i ' + i + ' indexOfSlide '+ indexOfSlide);
                if (i===indexOfSlide) {
                    $(e).fadeIn('fast');
                }
            });

            return this;
        };

        /**
         * Function to set the current slide, returns early if the index passed is out of the range, this is exposed
         * to the CarouselViewController so other elements on a page can set the position of the carousel.
         * @param index {int}
         * @return {*}
         */
        ImageGalleryView.prototype.setCurrentSlide = function (index) {
            if (index > this.slideCount || index < 0) {
                return this;
            }
            this.$slides.removeClass('MMM--isActive');

            $(this.$slides[index]).addClass('MMM--isActive');

            this.currentSlide = index;
            //this.animateTo(index);

            return this;
        };

        /**
         *  Looks through the current slides to see which slide is active
         *  ToDo make this check for the current active slide by looking at the current slide property, do not store state
         *  in the DOM
         */
        ImageGalleryView.prototype.getCurrentSlideID = function () {
            return this.$slides.filter('.MMM--isActive').attr('id');
        };

        /**
         * This is a method that allows the carousel to animate to a specific slide based on ID
         * @param {String || jQuery} slideId
         */
        ImageGalleryView.prototype.goToSlide = function (slideId) {
            console.log('class of slideId '+ $(slideId).attr('class') + ' id of slideId ' + $(slideId).attr('id'));
            var $slideElement = $(slideId);
            this.$slides.removeClass('MMM--isActive');

            $slideElement.addClass('MMM--isActive');

            try {
                if ($slideElement.length === 0) {
                    throw 'Slide ' + slideId + ' not found!';
                }
            } catch (error) {
                if (window.console) { window.console.log(error); }
                return;
            }
            var indexOfSlide = this.$slides.index($slideElement);
            //this.setCurrentSlide(indexOfSlide);
            this.$slides.each(function (i, e) {
                //$msg('i ' + i + ' indexOfSlide '+indexOfSlide + ' e '+ $(e).attr('class'));
                //if ()
                if (i===indexOfSlide) {
                    $(e).show();
                    $(e).css('display','list-item');
                }
                else {
                    $(e).hide();
                }
            });

            //$msg('img content '+this.imgContent);
            //this.enable();

            if ($(slideId).hasClass('js-galleryListVideo')) {
                this.mediagallery.loadVideoById($(slideId));
            }
            else {
                this.mediagallery.setContent();
            }
            this.enable();
            return this;
        };

        /**
         * Enables the view
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @returns {ImageGalleryView}
         * @since 1.0
         */
        ImageGalleryView.prototype.enable = function () {

            var self = this;
            /*
            if (this.isEnabled) {
                return this;
            }
            */
            this.isEnabled = true;

            this.$carousel.on(features.DOWN, this.onTapStartHandler);
            this.thumbnailControllerContainerId = '#' +this.$carousel.next('.MMM--galleryNavigationContainer_carousel').find('.js-gallery-Thumbnails-links').attr('id');
            this.mobileThumbnailContollerContainerId = '#' +  this.$carousel.next('.MMM--galleryNavigationContainer_carousel').find('.js-gallery-Thumbnails-links').attr('id');
            this.heroCarouselAltController = new CarouselController({carousel: this, triggerSelector: this.thumbnailControllerContainerId + ' > li > a'}, this);
            this.heroCarouselAltControllerMobile = new CarouselController({carousel: this, triggerSelector: this.mobileThumbnailContollerContainerId + ' > li > a'}, this);

            return this;
        };

        /**
         * Disables the view
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @returns {ImageGalleryView}
         * @since 1.0
         */
        ImageGalleryView.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            }

            this.isEnabled = false;

            // Tear down any event handlers
            this.$carousel.off(features.DOWN, this.onTapStartHandler);

            return this;
        };

        /**
         * Destroys the view
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @returns {ImageGalleryView}
         * @since 1.0
         */
        ImageGalleryView.prototype.destroy = function () {
            this.disable();

            return this;
        };

        ImageGalleryView.prototype.animateTo = function (index) {
            var width = this.$slides.width();
            var self = this;
            var animationProp = {};

            animationProp = {'display': -'block'};

            this.isAnimating = true;
            $msg('slide '+this.$slides.eq(index).attr('id'));
            this.$slides.each(function (i, e) {
                if (i===index) {
                    $(e).show();
                }
            });
          /*  .animate(animationProp,
                this.transitionSpeed,
                function () {
                    self.isAnimating = false;
                    //self.$slideIndicator.text(self.currentSlide + 1);
                });*/
        };

        /*******
         * Click/Touch Interactive Methods
         *******/

        /**
         * Activates the scroll action
         * Used to turn on any listeners after the carousel has been tapped
         *
         * @method activate
         * @chainable
         */
        ImageGalleryView.prototype.activate = function () {
            if (this.isActive) {
                return this;
            }

            this.isActive = true;
            this.$carousel.on(features.MOVE, this.onTapMoveHandler);
            this.$carousel.on(features.UP, this.onTapEndHandler);
            this.$carousel.on(features.CANCEL, this.onTapEndHandler);

            // Mobile IE
            // mouseleave is triggering and causing all mouse interaction to fail
            // Not yet fixed, but a possible solution would be to start listening to the document
            // And do manual testing based on mouse movements and hit tests
            if (features.useLeaveInteraction) {
                this.$carousel.on(features.LEAVE, this.onTapEndHandler);
            }
            this.$carousel.on('dragstart', 'img', this.onImageDragHandler);

            return this;
        };

        /**
         * Deactivates the scroll action
         * Used to turn off any listeners after the carousel has finished being tapped
         *
         * @method deactivate
         * @chainable
         */
        ImageGalleryView.prototype.deactivate = function () {
            if (!this.isActive) {
                return this;
            }

            this.isActive = false;
            this.$carousel.off(features.MOVE, this.onTapMoveHandler);
            this.$carousel.off(features.UP, this.onTapEndHandler);
            this.$carousel.off(features.CANCEL, this.onTapEndHandler);
            if (features.useLeaveInteraction) {
                this.$carousel.off(features.LEAVE, this.onTapEndHandler);
            }
            this.$carousel.off('dragstart', 'img', this.onImageDragHandler);

            return this;
        };

        return ImageGalleryView;
    });
}(MMMRequire));